export type NavigationLevel = 1 | 2 | 3;

/** What the tracking attributes need to know about a navigation entry. */
export interface NavigationTrackingEntry {
  /** Internal Name of the Contentful entry; not localized. */
  internalName?: string;
  /** Position in the entry's Contentful reference list. */
  index?: number;
}

/**
 * Data attributes the app's click tracking reads from the clicked menu entry.
 * Entries without an Internal Name are not tracked.
 */
export function getNavigationTrackingAttributes(
  entry: NavigationTrackingEntry,
  level: NavigationLevel
): Record<string, string | number> {
  if (!entry.internalName) {
    return {};
  }

  return {
    "data-nav-name": entry.internalName,
    "data-nav-level": level,
    "data-nav-index": entry.index ?? 0,
  };
}
